import styles from "./AboutUsPage.module.scss";
import {useTranslation} from "react-i18next";
import useAppSelector from "../../hooks/useAppSelector";
import defaultImage from "../../assets/images/about-us/default-image.png";
import {getImageUrlForContent} from "../../helpers/image.helper";

const AboutUsPage = () => {

    const {t} = useTranslation();
    const {content} = useAppSelector(state => state.siteContentSlice);

    return (
        <section className={styles.page}>
            <h2 className={styles.title}>{t("AboutUs")}</h2>
            <div className={"container"}>
                <div className={styles.wrapper}>
                    <div className={styles.item}>
                        <h3 className={styles.infoTitle}>{content.aboutUsTitle}</h3>
                        <p className={styles.text}>{content.aboutUsDescription}</p>
                    </div>
                    <div className={`${styles.item} ${styles.image}`}
                         style={{backgroundImage: `url(${ getImageUrlForContent(content.aboutUsBackgroundPath) ? getImageUrlForContent(content.aboutUsBackgroundPath) : defaultImage})`}}></div>
                </div>
            </div>
        </section>
    )
}

export default AboutUsPage;